import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "middle-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "information-method"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "information-text" }, "Método de pagamento", -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getMethods(), (method) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["card", {selected: method.type == $setup.selected?.type}]),
          onClick: () => {
          $setup.selected = method;
          _ctx.$emit('change-method', method.type);
        }
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["FontAwesomeIcon"], {
              icon: method.icon,
              size: '3x'
            }, null, 8 /* PROPS */, ["icon"]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(method.name), 1 /* TEXT */)
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_3))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    ($setup.selected && $setup.selected.msg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.selected?.msg), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}